const SW_CLEANUP_VERSION = 1 // if we want to hard reload service workers for clients, just increase this number

export function register() {
	if ('serviceWorker' in navigator) {
		window.addEventListener('load', async () => {
			// One-time cleanup for users with broken service worker
			try {
				const cleanupDone = localStorage.getItem('sw-cleanup-version')

				if (cleanupDone !== String(SW_CLEANUP_VERSION)) {
					// Only unregister our own service worker (not others on shared domains)
					const registrations = await navigator.serviceWorker.getRegistrations()
					await Promise.all(registrations.filter((reg) => reg.active?.scriptURL?.endsWith('/service-worker.js')).map((reg) => reg.unregister()))

					// Clear only our caches (wagenow-cache*)
					const cacheNames = await caches.keys()
					await Promise.all(cacheNames.filter((name) => name.startsWith('wagenow-cache')).map((name) => caches.delete(name)))

					localStorage.setItem('sw-cleanup-version', String(SW_CLEANUP_VERSION))
				}
			} catch (error) {
				console.error('Service worker cleanup failed:', error)
			}

			// Always register service worker, even if cleanup failed
			navigator.serviceWorker.register('/service-worker.js')
		})
	}
}
